import { useAtomValue } from "jotai";
import { useEffect, useRef } from "react";
import { canv } from "@/canv/global";
import { LinkPopupIcon } from "@/icons";
import { linkPopupStateAtom } from "@/interface/AppStore";
import { HStack } from "@/shared/ui/Stack";
import styles from "./LinkPopup.module.css";
import { calculatePopupCoordinates } from "./utils/calculatePopupCoordinates";
import { getLinkForView } from "./utils/getLinkForView";

export function LinkPopup() {
    const wrapperRef = useRef<HTMLDivElement>(null);
    const state = useAtomValue(linkPopupStateAtom);

    useEffect(() => {
        if (!state || !wrapperRef.current) {
            return;
        }

        const wrapper = wrapperRef.current;
        const wrapperRect = wrapper.getBoundingClientRect();
        const canvasRect = canv.canvas.getBoundingClientRect();
        const { left, top } = calculatePopupCoordinates(state, wrapperRect, canvasRect);

        wrapper.style.transform = `translate3d(${left}px, ${top}px, 0)`;
    }, [state]);

    if (!state) {
        return null;
    }

    const controller = canv.appInterface.linkPopupController;
    const url = state.url;

    const handlePointerDown = (event: React.PointerEvent) => {
        event.preventDefault();
    };

    const handleOpenLinkButtonClick = () => {
        window.open(url, "_blank", "noopener,noreferrer");
    };

    const handleCopyLinkButtonClick = async () => {
        try {
            await navigator.clipboard.writeText(url);
            canv.appInterface.infoWindow.open("Скопировано");
        } catch {
            console.warn("Link copy failed");
        }
    };

    const viewLink = getLinkForView(state.url);

    return (
        <HStack
            ref={wrapperRef}
            className={styles.wrapper}
            onPointerEnter={controller.onPopupPointerEnter}
            onPointerLeave={controller.onPopupPointerLeave}
            onPointerDown={handlePointerDown}
            data-ui-root="true"
        >
            <div className={styles.arrow} />
            <HStack className={styles.content}>
                <button className={styles.link} type="button" onClick={handleOpenLinkButtonClick}>
                    <LinkPopupIcon />

                    <span className={styles.linkText}>Открыть {viewLink}</span>
                </button>

                <div className={styles.divider} />

                <button className={styles.button} type="button" onClick={handleCopyLinkButtonClick}>
                    Скопировать
                </button>
            </HStack>
        </HStack>
    );
}
